









import {Component, Prop, Vue} from "vue-property-decorator";
import {MainPageConfig} from "@/interfaces/main-page.interface";

@Component
export default class LogoBox extends Vue {
  baseUrl = process.env.VUE_APP_PUBLIC_URL;

  @Prop() item: MainPageConfig.ISponsors;
}
